<template>
    <v-menu
        v-model="showPopup"
        lazy
        transition="scroll-y-transition"
        offset-y
        :nudge-top="-6"
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on }">
            <div :class="buttonClassName" class="centerY justify-space-between group-btn-time">
                <div class="btn-prev-time" @click.stop="prevOrNextTimeRange(false)">
                    <img src="/img/arrow-left_grey.svg" alt="icon_prev_time">
                </div>
                <div class="btn-calendar" v-on="on">
                    <img src="/img/calendar.svg" alt="icon_calendar" style="margin-right: 6px; transform: scale(1.05)">
                    <div style="white-space: nowrap; user-select: none">{{ textButton | capitalize }}</div>
                </div>
                <div class="btn-next-time" @click.stop="prevOrNextTimeRange(true)">
                    <img src="/img/arrow-left_grey.svg" alt="icon_next_time">
                </div>
            </div>
        </template>
        <div class="menu-container" :class="{mobile: utils.isMobile()}">
            <!--List option quickly-->
            <div class="quickly">
                <div class="title-tab">
                    {{ $f.tc('quickSelect') }}
                </div>
                <div class="btn-quickly" :class="model === option.value ? 'btn-quickly-active' : ''"
                     v-for="(option, index) in thisGroup" :key="index" @click="quickSelect(option)">
                    {{ $f.tc(option.i18n) }}
                </div>
            </div>
            <!--Time range custom-->
            <div class="custom">
                <div class="title-tab">
                    {{ $f.tc('custom') }}
                </div>
                <div class="content-custom">
                    <div class="from-datetime">
                        <div class="sub-title">{{ $f.tc('from') }}</div>
                        <div class="d-flex align-center">
                            <DateTimeInput
                                v-model="fromDate"
                                :label="$f.tc('date')"
                                :min="'1900-01-01'"
                                type="date"
                                :color="'#0052CC'"
                                style="margin-right: 6px"
                            ></DateTimeInput>
                            <DateTimeInput
                                v-model="fromTime"
                                :label="$f.tc('time')"
                                type="time"
                                :color="'#0052CC'"
                            ></DateTimeInput>
                        </div>
                    </div>
                    <div class="to-datetime">
                        <div class="sub-title">{{ $f.tc('to') }}</div>
                        <div class="d-flex align-center">
                            <DateTimeInput
                                v-model="toDate"
                                type="date"
                                :label="$f.tc('date')"
                                :min="fromDate || '1900-01-01'"
                                :max="today"
                                :color="'#0052CC'"
                                style="margin-right: 6px"
                            ></DateTimeInput>
                            <DateTimeInput
                                v-model="toTime"
                                :label="$f.tc('time')"
                                type="time"
                                :color="'#0052CC'"
                            ></DateTimeInput>
                        </div>
                    </div>
                </div>
                <v-scroll-y-transition>
                    <div class="mess-error" v-if="messageApplyError">{{ messageApplyError }}</div>
                </v-scroll-y-transition>
                <v-layout align-center justify-end style="margin-top: 20px">
                    <div style="flex: 1"></div>
                    <div class="btn-apply" @click="applyCustom">
                        {{ $f.tc('apply') }}
                    </div>
                    <div class="btn-cancel" @click="showPopup = false">
                        {{ $f.tc('cancel') }}
                    </div>
                </v-layout>
            </div>
        </div>
    </v-menu>
</template>

<script>
import {optionList, thisGroup} from '@/modules/fptai/components/TimeRangePickerQuickOptions'
import moment from 'moment'
import DateTimeInput from "@/components/DateTimeInput";
import $const from "@/utils/const";

const showTimeRangeTypes = $const.ShowTimeRangeTypes

export default {
    name: 'TimeRangePicker',
    components: {DateTimeInput},
    props: {
        value: String,
        buttonClassName: String
    },
    data() {
        return {
            typeShow: showTimeRangeTypes.QUICK_OPTION,
            showPopup: false,
            model: '',
            quickOption: {
                i18n: 'today',
                value: 'today',
                key: 'day',
                range: () => ({
                    from: moment().startOf('day').unix(),
                    to: moment().endOf('day').unix()
                })
            },
            today: moment().format('YYYY-MM-DD'),
            fromDate: null,
            fromTime: '00:00',
            toDate: null,
            toTime: '23:59',
            textButton: this.$t('timeRange'),
            utils: this.$utils,
            optionList: [],
            thisGroup: thisGroup,
            messageApplyError: ''
        }
    },
    mounted() {
        this.typeShow = this.value.includes('➜') ? showTimeRangeTypes.CUSTOM : showTimeRangeTypes.QUICK_OPTION
        this.updateFilter()
    },
    methods: {
        updateTypeShow (type) {
            this.typeShow = type ? type : this.typeShow
        },
        updateCustomTime(range) {
            let datetime = this.getTimeRange(range)
            if (datetime) {
                this.fromDate = datetime.fromDate
                this.fromTime = datetime.fromTime.slice(0, -3)
                this.toDate = datetime.toDate
                this.toTime = datetime.toTime.slice(0, -3)
            }
        },
        quickSelect(option) {
            this.model = option.value
            this.typeShow = showTimeRangeTypes.QUICK_OPTION
            this.quickOption = option
            this.updateCustomTime()
            this.showPopup = false
            this.$emit('input', this.model)
        },
        applyCustom() {
            this.typeShow = showTimeRangeTypes.CUSTOM
            if (this.fromDate && this.toDate) {
                let timeRange = this.getEpoch()
                if (timeRange.to < timeRange.from) {
                    this.messageApplyError = this.$f.tc('invalidFilterData')
                } else {
                    this.quickOption = null
                    this.model = `${this.fromDate} ${this.fromTime ? this.fromTime : ''} ➜ ${this.toDate} ${this.toTime ? this.toTime : ''}`
                    this.showPopup = false
                    this.$emit('input', this.model)
                }
            } else {
                this.messageApplyError = this.$f.tc('pleaseEnterAllFields')
            }
        },
        updateTextButton() {
            this.textButton = this.$f.tc('timeRange')
            if (this.typeShow === showTimeRangeTypes.QUICK_OPTION) {
                this.textButton = this.$f.tc(this.quickOption.i18n)
            } else {
                this.textButton = `${this.fromDate} ${this.fromTime ? this.fromTime : ''} ➜ ${this.toDate} ${this.toTime ? this.toTime : ''}`
            }
        },
        getEpoch() {
            let timeRange = null
            if (this.typeShow === showTimeRangeTypes.QUICK_OPTION) {
                timeRange = this.quickOption.range()
            } else {
                let fromTime = this.fromTime ? this.fromTime + ':00' : '00:00:00'
                let toTime = this.toTime ? this.toTime + ':59' : '23:59:59'
                timeRange = {
                    from: this.$utils.convertToTimestamp(this.fromDate, fromTime),
                    to: this.$utils.convertToTimestamp(this.toDate, toTime)
                }
            }
            return timeRange
        },
        getTimeRangeInDjango() {
            let timeRange = this.getEpoch()
            let format = 'YYYY-MM-DD HH:mm:ssZZ'
            let startDate = moment.unix(timeRange.from).format(format)
            let endDate = moment.unix(timeRange.to).format(format)
            return {
                from: startDate,
                to: endDate
            }
        },
        getTimestamp() {
            let timeRange = this.getEpoch()
            return {
                from: timeRange.from * 1000,
                to: timeRange.to * 1000
            }
        },
        getTimeRange(range) {
            let timeRange = range ? range : this.getEpoch()
            let from = this.$utils.convertTimestamp(timeRange.from)
            let to = this.$utils.convertTimestamp(timeRange.to)
            return {
                fromDate: from.date,
                fromTime: from.time,
                toDate: to.date,
                toTime: to.time
            }
        },
        updateFromToCustom (val) {
            let split = val.split('➜')
            let from = split[0].trim()
            let to = split[1].trim()
            this.fromDate = from.split(' ')[0].trim()
            this.fromTime = from.split(' ')[1] ? from.split(' ')[1].trim() : ''
            const fromTimeSplit = this.fromTime.split(':')
            this.fromTime = fromTimeSplit.length > 0 ? `${fromTimeSplit[0]}:${fromTimeSplit[1]}` : ''
            this.toDate = to.split(' ')[0].trim()
            this.toTime = to.split(' ')[1] ? to.split(' ')[1].trim() : ''
            const toTimeSplit = this.toTime.split(':')
            this.toTime = toTimeSplit.length > 0 ? `${toTimeSplit[0]}:${toTimeSplit[1]}` : ''
        },
        updateFilter() {
            if (typeof this.value === 'string') {
                this.model = this.value
                if (this.value.includes('➜')) {
                    this.updateFromToCustom(this.value)
                } else {
                    this.updateCustomTime()
                    this.quickOption = optionList.find(option => option.value === this.value)
                }
                this.updateTextButton()
            }
        },
        getPeriod() {
            let from = moment(`${this.fromDate} ${this.fromTime}:00`)
            let to = moment(`${this.toDate} ${this.toTime}:59`)
            return to.diff(from, 'seconds')
        },
        prevOrNextTimeRange(isNext) {
            let from, to
            let fromTime = `${this.fromDate} ${this.fromTime}:00`
            let toTime = `${this.toDate} ${this.toTime}:59`
            if (this.quickOption) {
                let keyTime = this.quickOption.key
                let startOrEndKey = keyTime === 'week' ? 'isoWeek' : keyTime
                if (isNext) {
                    from = moment(fromTime).add(1, keyTime).startOf(startOrEndKey).toDate()
                    to = moment(toTime).add(1, keyTime).endOf(startOrEndKey).toDate()
                } else {
                    from = moment(fromTime).subtract(1, keyTime).startOf(startOrEndKey).toDate()
                    to = moment(toTime).subtract(1, keyTime).endOf(startOrEndKey).toDate()
                }
            } else {
                let period = this.getPeriod() + 1
                from = isNext ? moment(fromTime).add(period, 'seconds').toDate() : moment(fromTime).subtract(period, 'seconds').toDate()
                to = isNext ? moment(toTime).add(period, 'seconds').toDate() : moment(toTime).subtract(period, 'seconds').toDate()
            }
            this.typeShow = showTimeRangeTypes.CUSTOM
            this.updatePrevOrNextTime(from, to)
            this.$emit('input', this.model)
        },
        updatePrevOrNextTime(from, to) {
            this.updateCustomTime({
                from: from.getTime() / 1000,
                to: to.getTime() / 1000
            })
            this.model = `${this.fromDate} ${this.fromTime ? this.fromTime : ''} ➜ ${this.toDate} ${this.toTime ? this.toTime : ''}`
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function () {
                this.updateFilter()
            }
        },
        model: 'updateTextButton',
        showPopup: function () {
            this.messageApplyError = ''
            this.updateFilter()
        },
        '$i18n.locale': 'updateTextButton'
    }
}
</script>

<style scoped lang="scss">
.menu-container {
    background: #fff;
    width: 480px;
    display: flex;
    border-radius: 5px;
    &.mobile {
        width: 100%;
    }

    .title-tab {
        font-weight: 700;
        font-size: 14px;
        text-align: center;
    }

    .quickly {
        width: 150px;
        padding: 10px;
        border-right: 1px solid #E4EDFA;

        .btn-quickly {
            width: 100%;
            text-align: center;
            height: 30px;
            line-height: 30px;
            border: 1px solid #D9D9D9;
            margin-top: 10px;
            font-size: 14px;
            border-radius: 5px;
            cursor: pointer;
            color: #617CA5;

            &:hover {
                background: #e6f4ff;
            }
        }

        .btn-quickly-active {
            color: #0052CC !important;
            border-color: #0052CC !important;
            background: #e6f4ff;
            font-weight: 700;
        }
    }

    .custom {
        padding: 10px;
        flex: 1;
        position: relative;
    }

    .content-custom {
        margin-top: 10px;
    }

    .mess-error {
        position: absolute;
        font-size: 12px;
        bottom: 40px;
        left: 21px;
        color: #ff5252;
    }

    .from-datetime, .to-datetime {
        border-radius: 5px;
        border: 1px solid #D9D9D9;
        padding: 20px 10px 10px 10px;
        position: relative;
        margin-top: 20px;
    }

    .sub-title {
        position: absolute;
        background: #FFFFFF;
        top: -14px;
        left: 10px;
        font-size: 14px;
        padding: 0 5px;
    }

    .btn-cancel, .btn-apply {
        border-radius: 5px;
        border: 1px solid #0052CC;
        padding: 5px 10px;
        height: 30px;
        font-size: 14px;
        color: #0052CC;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .btn-apply {
        color: #FFFFFF !important;
        background: #0052CC;
        margin-right: 6px;
    }
}

.option {
    &:hover {
        background: #ffe4e4;
    }

    &.active {
        background: #1976d2;

        a {
            color: #fff;
        }
    }
}

.group-btn-time {
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #DBDBDB;
    color: #0052CC;
    background: #FFFFFF;
    padding: 0 4px;
    height: 32px;
    line-height: 32px;
}

.btn-calendar {
    background: #FFFFFF;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex: 1 !important;
    cursor: default;
    font-family: "open sans semi",serif;
}

.btn-prev-time, .btn-next-time {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
        background: #EBEBEB;
    }

    img {
        transform: scale(0.8);
    }
}

.btn-next-time {
    transform: rotate(180deg);
}

::v-deep {
    .v-text-field__details {
        display: none;
    }

    .v-input__slot {
        margin-bottom: 0 !important;
    }
}
</style>
